import React, { useEffect, useState } from 'react';
import { Container, Form } from '../Payment/Payment.styles';
import PaymentHeader from '../Payment/components/PaymentHeader';
import { LoadingRow, TypeDescription, TypeImage, TypeItem, TypeRadio, TypeTitle, TypesWrapper } from './InspectionType.styles';
import { InspectionTypeEnum } from '../../models/enums/inspection-type.enum';
import { useHistory } from 'react-router-dom';
import { LocalStoreKeysEnum } from '../../models/enums/localstore-keys.enum';
import { CircularProgress } from '@mui/material';
import whitelabelService from '../../services/whitelabel/whitelabel.service';

const InspectionType = () => {
  const whitelabelCompany = whitelabelService.getWBDataCompany();

  const history = useHistory();
  const [type, setType] = useState('');
  const [loading, setLoading] = useState(false);

  const inspectionTypeStyle = {
    checked: {
      borderColor: '#D40020'
    },
    opaque: {
      opacity: 0.5
    },
    disabled: {
      opacity: 0.5,
      cursor: 'not-allowed',
      pointerEvents: 'none' as const
    }
  }

  const isAgriculturalMachineDisabled = !whitelabelCompany.allowAgriculturalMachine;

  const getStatusStyle = (fieldType: string) => {
    if (fieldType === InspectionTypeEnum.AGRICULTURAL_MACHINE && isAgriculturalMachineDisabled) {
      return inspectionTypeStyle.disabled;
    }

    if (type === '') return {};

    if (fieldType === type) return inspectionTypeStyle.checked;

    return inspectionTypeStyle.opaque;
  }

  useEffect(() => {
    if (!type || type === '') return;
    setTimeout(() => {
      setLoading(true);
    }, 500);

    setTimeout(() => {
      localStorage
        .setItem(LocalStoreKeysEnum.INSPECTION_TYPE_KEY, type);

      history.push('vehicle-identifier');
    }, 2000);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [type]);

  return (
    <Container>
      <PaymentHeader isInspectionType />
      <Form>
        {!loading && (
          <TypesWrapper>
            <TypeItem
              style={getStatusStyle(InspectionTypeEnum.VEHICLE)}
              onClick={(e: any) => { setType(InspectionTypeEnum.VEHICLE) }}
            >
              <TypeTitle>
                <TypeRadio
                  type="radio"
                  name="type"
                  checked={type === InspectionTypeEnum.VEHICLE}
                  value={InspectionTypeEnum.VEHICLE}
                  onChange={(e: any) => { setType(e.target.value) }}
                />
                <span>Veículos leves ou pesados</span>
              </TypeTitle>
              <TypeImage src="images/inspection-type/truck-car.svg" />
              <TypeDescription>
                Para carro, moto, caminhão<br />ou semirreboque
              </TypeDescription>
            </TypeItem>
            <TypeItem
              style={getStatusStyle(InspectionTypeEnum.AGRICULTURAL_MACHINE)}
              onClick={() => { if (!isAgriculturalMachineDisabled) setType(InspectionTypeEnum.AGRICULTURAL_MACHINE) }}
            >
              <TypeTitle>
                <TypeRadio
                  type="radio"
                  name="type"
                  checked={type === InspectionTypeEnum.AGRICULTURAL_MACHINE}
                  value={InspectionTypeEnum.AGRICULTURAL_MACHINE}
                  onChange={(e: any) => { /* istanbul ignore else */ if (!isAgriculturalMachineDisabled) setType(e.target.value) }}
                  disabled={isAgriculturalMachineDisabled}
                />
                <span>Tratores agrícolas ou <br></br> tratores de linha amarela</span>
              </TypeTitle>
              <TypeImage src="images/inspection-type/machine.svg" />
              <TypeDescription>
                {whitelabelCompany.allowAgriculturalMachine
                  ? (<>Exclusiva para tratores.<br />Não vistoriamos implementos.</>)
                  : "Em breve!"}
              </TypeDescription>
            </TypeItem>
            {whitelabelCompany.allowVessel && (
              <TypeItem
                style={getStatusStyle(InspectionTypeEnum.VESSEL)}
                onClick={() => { setType(InspectionTypeEnum.VESSEL) }}
              >
                <TypeTitle>
                  <TypeRadio
                    type="radio"
                    name="type"
                    checked={type === InspectionTypeEnum.VESSEL}
                    value={InspectionTypeEnum.VESSEL}
                    onChange={(e: any) => { setType(e.target.value) }}
                  />
                  <span>Embarcações</span>
                </TypeTitle>
                <TypeImage src="images/inspection-type/vessel.svg" />
                <TypeDescription>
                  Para motos aquáticas e<br /> embarcações de esporte e/ou recreio
                </TypeDescription>
              </TypeItem>
            )}
          </TypesWrapper>
        )}
        {loading && (
          <LoadingRow>
            <CircularProgress sx={{ color: '#D40020' }} size={42} />
          </LoadingRow>
        )}
      </Form>
    </Container>
  );
}

export default InspectionType;
